import React, { useState, useEffect } from "react";

export default function ModalImagemQr({ isOpen, base64Image, tempo }) {
  
    if (!isOpen) return null; // Se a modal não estiver aberta, não renderiza nada
  
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-4 rounded-lg shadow-lg flex flex-col items-center">
        <h2 className="text-lg font-bold mb-4 text-center">Escaneie o QR Code</h2>
        <img
          src={`data:image/png;base64,${base64Image}`}
          alt="Imagem"
          className="w-[150px] h-[150px] object-contain rounded"
        />
      </div>
    </div>
  );
}